import $ from "jquery";
import "slick-slider";

const defaultConfig = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  accessibility: true,
  autoplay: false,
  responsive: [
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
};

export default (el, customConfig) => {
  const $el = $(el);
  const $slider = $el.find(".js-slide-container");
  const $slideNextButton = $el.find(".js-slide-next-button");
  const $slidePrevButton = $el.find(".js-slide-prev-button");
  const $slidePagination = $el.find(".js-slide-pagination");
  const $slideBar = $el.find(".js-slide-position-bar");
  const $slideStatus = $el.find(".js-slide-status");

  $slider.show();

  const config = {
    nextArrow: $slideNextButton,
    prevArrow: $slidePrevButton,
    ...defaultConfig,
    ...customConfig,
  };

  if ($slidePagination) {
    config.dots = true;
    config.appendDots = $slidePagination;
  }

  if (config.slidesToShow > 2) {
    config.responsive = [
      {
        breakpoint: 780,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      ...config.responsive,
    ];
  }

  if (config.slidesToShow > 3) {
    config.responsive = [
      {
        breakpoint: 910,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      ...config.responsive,
    ];
  }

  if (config.slidesToShow > 4) {
    config.responsive = [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      ...config.responsive,
    ];
  }

  // need to bind `init` BEFORE initializing the slider
  $slider.on("init", function (event, slick) {
    // setting left: 0 gives a start point to smoothly animate from, in case
    // the value is not set in CSS (which can cause jumpy first anim)
    $slideBar.css({
      "inset-inline-start": 0,
      width: 100 * (slick.options.slidesToShow / slick.slideCount) + "%",
    });
  });

  $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    // Updating bar width every change, in case the viewport has changed
    // responsive sliders may have different slidesToShow value
    $slideBar.css({
      "inset-inline-start": (nextSlide / slick.slideCount) * 100 + "%",
      width: 100 * (slick.options.slidesToShow / slick.slideCount) + "%",
    });

    // Add class to slide while animating

    slick.$slides[currentSlide].classList.add("slick-animating");
    slick.$slides[nextSlide].classList.add("slick-animating");
  });

  $slider.on("afterChange", function (event, slick, currentSlide) {
    for (const slide of slick.$slides) {
      slide.classList.remove("slick-animating");
    }

    if ($slideStatus.length) {
      const slideEnd =
        currentSlide + slick.options.slidesToShow > slick.slideCount
          ? slick.slideCount
          : currentSlide + slick.options.slidesToShow;
      $slideStatus.text(
        `Showing items ${currentSlide + 1} to ${slideEnd} of ${slick.slideCount}`,
      );
    }
  });

  const createSlider = () => {
    $slider.slick(config);
  };

  const destroySlider = () => {
    // This removed all html in the slider when I tried it
    // need to see if this works if the responsive setting isn't doing unslick
    //$slider.slick("unslick");
  };

  createSlider();

  return {
    $slider,
    createSlider,
    destroySlider,
  };
};
